import useSWRMutation from 'swr/mutation';
import { ActionsEmailPreviewDto, EmailActionsModel, SuccessResponse } from '@interfaces/central-monitoring';
import {
    BulkUpdateActionsDto,
    CreateActionModel,
    DeleteActionModel,
    UpdateActionModel,
} from '@interfaces-clean/actions.interface';

import { postData } from '@apis/rest-client';

const actionUrl = 'CentralMonitoring/Actions';

const ActionsApi = {
    useSave: (studyRef: string) => {
        return useSWRMutation(`${actionUrl}/Add/${studyRef}`, (url: string, { arg }: { arg: CreateActionModel }) => {
            return postData<CreateActionModel, SuccessResponse>(url, { arg, timeout: 30000 });
        });
    },
    useUpdate: (studyRef: string) => {
        return useSWRMutation(`${actionUrl}/Update/${studyRef}`, (url: string, { arg }: { arg: UpdateActionModel }) => {
            return postData<UpdateActionModel, SuccessResponse>(url, { arg, timeout: 30000 });
        });
    },
    useDelete: (studyRef: string) => {
        return useSWRMutation(`${actionUrl}/Delete/${studyRef}`, (url: string, { arg }: { arg: DeleteActionModel }) => {
            return postData<DeleteActionModel, boolean>(url, { arg, timeout: 30000 });
        });
    },
    useCanEmail: (studyRef: string) => {
        return useSWRMutation(`${actionUrl}/Email/Preview/${studyRef}`, (url: string, { arg }: { arg: string[] }) => {
            return postData<string[], ActionsEmailPreviewDto>(url, { arg, timeout: 30000 });
        });
    },
    useSendEmail: (studyRef: string) => {
        return useSWRMutation(`${actionUrl}/Email/${studyRef}`, (url: string, { arg }: { arg: EmailActionsModel }) => {
            return postData<EmailActionsModel, boolean>(url, { arg, timeout: 30000 });
        });
    },
    useBulkUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${actionUrl}/bulkUpdate/${studyRef}`,
            (url: string, { arg }: { arg: BulkUpdateActionsDto }) => {
                return postData<BulkUpdateActionsDto, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
};

export default ActionsApi;
